import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import { PatientService, LoginService, DoctorService } from '../../services';
import { useEffect, useState } from 'react';
import ProgressBar from "react-bootstrap/ProgressBar";
import BootstrapModal from "react-bootstrap/Modal";

const headers = {
  "SystemDate": "Date",
  "FirstName": "Hasta Adı",
  "FamilyName": "Hasta Soyadı",
  "FullName": "Doktor Adı",
  "Img1": "img1",
  "Img2": "img2",
  "Img3": "img3",
  "Img4": "img4",
  "Img5": "img5",
  "Img6": "img6",
  "Img7": "img7",
  "Img8": "img8",
  "Img9": "Panoramic",
  "Img10": "Sefalometric",
  "Img11": "Upper arch",
  "Img12": "Lower arch"
}



function PatientFiles() {
  const [imagesets, setImageSets] = useState([]);
  const [showProgress, setShowProgress] = useState(false)
  const [downloadProgress, setDownloadProgress] = useState(0.0)

  const downloadFile = (fileUrl, filename) => {
    console.log("file save started");
    setShowProgress(true)
    PatientService.downloadFile(fileUrl, setDownloadProgress)
    .then((response) => {
      console.log("download completed");
      // create file link in browser's memory
      const href = URL.createObjectURL(response);
  
      // create "a" HTML element with href to file & click
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
  
      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    }).finally(()=> {
      setShowProgress(false)
      setDownloadProgress(0)
    });
  
    console.log("file save ended");
  };
  
  
  function getDownloadLink(obj, value) {
    if (obj[value])
      return <td key={value}> <Link
        onClick={() =>
          downloadFile(LoginService.generateImageUrl(obj[value]), obj[value])
        }
      >
        {" "}
        {obj[value].slice(-6)}
      </Link>   </td>
  
    else return <td key={value}>-</td>
  }

  function createDownloadZipLink(imageSet) {
return   <td> 
  <Link onClick={() => downloadFile(LoginService.generateZipDownloadUrl(imageSet.Id1), imageSet.Id1 + "_" + imageSet.FirstName + "_" + imageSet.FamilyName + ".zip")}>
  Dowload Zip File
</Link>   
</td>
  
  }
  
  function createRow(imageset, index) {
    return <tr key={imageset.Id1 || index}>
      {
        Object.keys(headers).map((header) => {
          if (header.includes("Img"))
            return getDownloadLink(imageset, header)
          else return <td key={header}> {imageset[header]} </td>
        })
      }    
      {createDownloadZipLink(imageset)}

    </tr>
  }

  useEffect(() => {
    DoctorService.getImageSets().then((response) => {
      if (Array.isArray(response)) {
        setImageSets(response);
      } else {
        console.warn("getImageSets response is not an array:", response);
        setImageSets([]);
      }
    });

    return () => { };
  }, []);

  return (<>
   <Table striped bordered hover className='col-5'>
      <thead>
        <tr>
          {
            Object.keys(headers).map((header) => {
              return <th key={header}>{headers[header]}</th>
            })

            
          }

        <th>Download All</th>
        </tr>
      </thead>
      <tbody>
        {
          Array.isArray(imagesets) && imagesets.map((imageset, index) => {
            return createRow(imageset, index)
          })
        }
      </tbody>
    </Table>

{showProgress && (
  <BootstrapModal show={showProgress}>
    <BootstrapModal.Body>
      <ProgressBar variant="warning" animated now={downloadProgress} />
    </BootstrapModal.Body>
  </BootstrapModal>
)}
  </>
   
  );
}

export default PatientFiles;